<script lang="ts">
  import ArrowLink from "$lib/atoms/ArrowLink.svelte";
  import { parseUrl } from "$lib/utils/helpers";
  import optimizeImage, { aspectRatio } from "$lib/utils/optimizeImage";

  export let post: any;
  let isExternalLink = post?.content?.externalLink?.url?.length > 0;
</script>

{#if post && post.full_slug}
  <a
    href={post?.content?.externalLink?.url || "/" + parseUrl(post.full_slug)}
    target={isExternalLink ? "_blank" : ""}
    rel={isExternalLink ? "noopener noreferrer" : ""}
    class="bg-sand p-[1rem] h-full flex flex-col rounded-md overflow-hidden no-underline group"
  >
    <div class="aspect-square rounded-md overflow-hidden bg-yellow">
      {#if post?.content?.mastheadImage?.filename}
        <img
          src={optimizeImage(post.content.mastheadImage.filename)}
          alt={post?.content?.mastheadImage?.alt}
          class="h-full w-full object-cover"
          style={aspectRatio(post.content.mastheadImage.filename)}
          loading="lazy"
        />
      {/if}
    </div>
    <div
      class="p-3 pt-5 xl:pb-[30px] xl:pt-[45px] xl:px-[25px] flex-1 flex flex-col gap-8 md:gap-[50px] justify-between"
    >
      <div>
        {#if post?.content?.logo?.filename}
          <div class="mb-4 md:mb-6">
            <img
              src={optimizeImage(post.content.logo.filename)}
              alt={post?.content?.logo?.alt}
              class="rounded-md overflow-hidden"
              style={aspectRatio(post.content.logo.filename)}
              loading="lazy"
            />
          </div>
        {/if}
        <h2 class="type:body-title text-charcoal">
          {@html post?.content?.previewHeading || post.name}
        </h2>
      </div>

      <div>
        <ArrowLink class="reduced hover-red-bg bg-transparent"
          >Read More</ArrowLink
        >
      </div>
    </div>
  </a>
{/if}
